"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../actions/types");
var initialState = _types.UI.LOADING;
var chatUiReducer = function chatUiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    value = action.value;
  switch (type) {
    case _types.LOAD_CHATS_START:
      return _types.UI.LOADING;
    case _types.LOAD_CHATS_ERROR:
      switch (state) {
        case _types.REASON.USER_NOT_LOGGED:
        case _types.REASON.NO_INTERNET:
          return state;
        default:
          return value.reason;
      }
    case _types.CHAT_UNKNOWN_ERROR:
      return _types.REASON.UNKNOWN_ERROR;
    case _types.REASON.USER_NOT_LOGGED:
    case _types.REASON.NO_INTERNET:
      return type;
    case _types.RECEIVE_CHATS:
    case _types.LOAD_CHATS_DONE:
      return _types.UI.LIST_CHATS;
    default:
      return state;
  }
};
var _default = exports["default"] = chatUiReducer;